/**
 * Copyright (c) 2018-present, Luojun Jin
 *
 * @emails john.king.ca@gmail.com
 */


import React from 'react';
import {colors} from 'theme';
import { css } from 'react-emotion';
import PropTypes from 'prop-types';

/**
 * Basic element component for higher order component composition
 * @param children child components
 * @param title
 * @param cssProps more specific styles
 * @param onDark dark/light theme
 */
const MetaTitle = ({children, title, cssProps = {}, onDark = false}) => {
  const className = css({
    color: onDark ? colors.subtleOnDark : colors.subtle,
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 3,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    ...cssProps,
  });

  return (
    <div className={className}>
      {title}
      {children}
    </div>
  );
};

MetaTitle.prototype = {
  title: PropTypes.string.isRequired,
};

MetaTitle.defautPropTypes = {
  title: '',
};

export default MetaTitle;
